import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const processData = [
    {
        id: 1,
        title: "Confirming Receipt",
        description: "Once we receive your application, we’ll send you a confirmation email. Our hiring team will then review your profile, and we’ll keep you informed as your application moves through the recruitment process. ",
        image: "/assets/recruiting/img1.png"
    },
    {
        id: 2,
        title: "Reviewing your application",
        description: "Our team carefully reviews your experience, skills, and background to understand what makes you unique and how your strengths can contribute to the success of the role and our organization.",
        image: "/assets/recruiting/img1.png"
    },
    {
        id: 3,
        title: "Reaching out",
        description: "When your skills and experience align with what we're looking for, a recruiter will connect with you for an initial conversation. We’re excited to learn more about your journey, your goals, and how we can grow together. ",
        image: "/assets/recruiting/img1.png"
    },
    {
        id: 4,
        title: "Meeting You",
        description: "We look forward to connecting with you through virtual or in-person interviews. It’s an opportunity for us to learn more about your journey and expertise, while helping you gain a better understanding of the role, team, and what it’s like to work with us. ",
        image: "/assets/recruiting/img1.png"
    },
    {
        id: 5,
        title: "Assessing your Skills",
        description: "Depending on the position, you may be asked to complete a technical assessment or case study. Think of it as a chance to highlight your expertise, problem-solving abilities, and the unique value you can bring to the role. ",
        image: "/assets/recruiting/img1.png"
    },
    {
        id: 6,
        title: "Offering you a role",
        description: "If all goes well, we’ll be excited to offer you a position on our team and welcome you aboard. We look forward to supporting you as you begin this new and rewarding chapter with us. ",
        image: "/assets/recruiting/img1.png"
    }
];

const OurProcessSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section className="w-full py-[40px] md:py-[100px] bg-white">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="mb-[24px] md:mb-[60px]"
                >
                    <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight">
                        Our Process
                    </h2>
                </motion.div>

                <div className="flex flex-col lg:flex-row gap-[24px] md:gap-[40px] lg:gap-[100px]">

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.1 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        variants={{
                            lg: { initial: { opacity: 0, x: -30, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                        }}
                        className="w-full lg:w-1/2 flex flex-col"
                    >
                        {processData.map((step, index) => {
                            const isActive = activeIndex === index;

                            return (
                                <div key={step.id} className="flex flex-col">
                                    <div
                                        onClick={() => setActiveIndex(isActive && window.innerWidth < 1024 ? -1 : index)}
                                        onMouseEnter={() => window.innerWidth >= 1024 && setActiveIndex(index)}
                                        className={`flex justify-between items-center py-[16px] md:py-[24px] cursor-pointer transition-all duration-300 border-b-[2px] ${isActive ? "border-[#ED6800]" : "border-[#D5D5D5] hover:border-[#01386A40]"
                                            }`}
                                    >
                                        <h3 className={`font-sora text-[16px] md:text-[20px] transition-colors duration-300 pr-4 ${isActive ? "font-[600] text-[#01386A]" : "font-[600] text-[#0000008C] hover:text-[#01386A]"
                                            }`}>
                                            {step.title}
                                        </h3>

                                        <div className={`text-[20px] font-[500] transition-all duration-300 shrink-0 ${isActive ? "text-[#ED6800] opacity-100 translate-x-0 rotate-90 lg:rotate-0" : "text-transparent lg:text-[#0000008C] opacity-0 lg:opacity-0 -translate-x-2 lg:group-hover:opacity-100"
                                            }`}>
                                            &gt;
                                        </div>
                                    </div>

                                    <div className={`block lg:hidden overflow-hidden transition-[max-height] duration-300 ease-in-out ${isActive ? 'max-h-[1000px]' : 'max-h-0'}`}>
                                        <div className="py-5 border-b border-[#D5D5D5]">
                                            <p className="font-graphik text-[#6C7689] lg:text-[16px] text-[14px] font-[500] leading-[1.6] mb-4">
                                                {step.description}
                                            </p>
                                            <div className="w-full max-w-[500px] h-[200px] sm:h-[260px] overflow-hidden bg-[#F5F6F8] rounded-sm shadow-sm">
                                                <img
                                                    src={step.image}
                                                    alt={step.title}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </motion.div>

                    <div className="hidden lg:flex w-full lg:w-1/2 pt-[24px]">
                        <AnimatePresence mode="wait">
                            {activeIndex !== -1 && (
                                <motion.div
                                    key={activeIndex}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{ duration: 0.4, ease: "easeOut" }}
                                    className="flex flex-col gap-[30px] md:gap-[50px] h-full"
                                >
                                    <p className="font-graphik text-[#6C7689] text-[14px] md:text-[16px] font-[500] leading-[1.6] max-w-[500px]">
                                        {processData[activeIndex]?.description}
                                    </p>

                                    <div className="w-full max-w-[500px] h-[250px] sm:h-[300px] md:h-[380px] overflow-hidden bg-[#F5F6F8] mt-auto rounded-sm shadow-sm group cursor-pointer">
                                        <img
                                            src={processData[activeIndex]?.image}
                                            alt={processData[activeIndex]?.title}
                                            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                        />
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default OurProcessSection;